import axios from "axios"
import { ICalibration } from "../../@types/ICalibration"

const POLL_INTERVAL = 10000 //10s
const TIMEOUT = 10000 //15s

export const projectAPI = {
  /**
   * Call ping api from vpnsetup server
   */
  pingDevice: async (input: {
    token: string
    apiGatewayUrl: string
    projectId: string
    host: string
    port: string
    username: string
    password: string
    devicetype: string
    rtsplink: string
    portrtsp: string
    portforwarded: string
    portforwardedrtsp: string
    remotehostname: string
    remotehostip: string
  }) => {
    const {
      token,
      apiGatewayUrl,
      projectId,
      host,
      port,
      username,
      password,
      devicetype,
      rtsplink,
      portrtsp,
      portforwarded,
      portforwardedrtsp,
      remotehostname,
      remotehostip,
    } = input
    const res = await axios.post(
      `${apiGatewayUrl}/calibrationHelpers/_testconnection`,
      {
        projectId,
        host,
        port,
        username,
        password,
        devicetype,
        rtsplink,
        portrtsp,
        portforwarded,
        portforwardedrtsp,
        remotehostname,
        remotehostip,
      },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        timeout: 10 * 60000,
      }
    )

    if (!res.data) throw new Error("ping failed")
  },
  /**
   * gets the camera driver status
   */

  getCameraDriverStatus: async (input: {
    token: string
    apiGatewayUrl: string
    projectId: string
    deploymentId: string
  }) => {
    const { token, apiGatewayUrl, projectId, deploymentId } = input
    return axios.post(
      `${apiGatewayUrl}/cameraSetupHelpers/status/`,
      {
        projectId,
        deploymentId,
      },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    )
  },
  /**
   * Creates a camera setup
   */
  createCameraSetup: async (input: {
    token: string
    apiGatewayUrl: string
    projectId: string
    deploymentId: string
  }) => {
    const { token, apiGatewayUrl, projectId, deploymentId } = input
    return axios.post(
      `${apiGatewayUrl}/cameraSetupHelpers/`,
      {
        projectId,
        deploymentId,
      },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    )
  },
  /**
   * deletes a camera setup
   */
  deleteCameraSetup: async (input: {
    token: string
    apiGatewayUrl: string
    projectId: string
    deploymentId: string
  }) => {
    const { token, apiGatewayUrl, projectId, deploymentId } = input
    return axios.delete(`${apiGatewayUrl}/cameraSetupHelpers/`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: {
        projectId,
        deploymentId,
      },
    })
  },
  /**
   * gets the camera driver status
   */

  getCumulativeCounterStatus: async (input: {
    token: string
    apiGatewayUrl: string
    projectId: string
    deploymentId: string
    calibrationId: string
  }) => {
    const { token, apiGatewayUrl, projectId, deploymentId, calibrationId } = input
    return axios.post(
      `${apiGatewayUrl}/cameraSetupHelpers/cumulativecounters/status/`,
      {
        projectId,
        deploymentId,
        calibrationId,
      },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    )
  },
    /**
   * Creates a camera setup
   */
  createCumulativeCounter: async (input: {
    token: string
    apiGatewayUrl: string
    projectId: string
    deploymentId: string
    calibrationId: string
    countLine?: string
    maskDistance: number
    rtspUrl: string
  }) => {
    const { token, apiGatewayUrl, projectId, deploymentId, calibrationId, countLine, maskDistance, rtspUrl } = input
    return axios.post(
      `${apiGatewayUrl}/cameraSetupHelpers/cumulativecounters`,
      {
        projectId,
        deploymentId,
        calibrationId,
        ...(countLine && { countLine }),
        maskDistance,
        rtspUrl
      },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    )
  },
  /**
   * deletes a camera setup
   */
  deleteCumulativeCounter: async (input: {
    token: string
    apiGatewayUrl: string
    projectId: string
    deploymentId: string
    calibrationId: string
  }) => {
    const { token, apiGatewayUrl, projectId, deploymentId, calibrationId } = input
    return axios.delete(`${apiGatewayUrl}/cameraSetupHelpers/cumulativecounters`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: {
        projectId,
        deploymentId,
        calibrationId,
      },
    })
  },
}
